export interface DoctorSaleEntry {
  id: string;
  amountPerTip: number;
  dr01: number;
  dr02: number;
  dr03: number;
  drOther: number;
  drTip: number;
  personTime: string;
  total: number;
  tr04: number;
  tr06: number;
  tr30: number;
  tr97: number;
  trOther: number;
  treatmentDepartmentId: number;
  treatmentDepartmentName: string;
  treatmentDoctorId: number;
  treatmentDoctorName: string;
}

export interface DoctorSalesResult {
  headers: string[];
  entries: DoctorSaleEntry[];
}

export function fromJson(json: any): DoctorSaleEntry {
  return {
    id: json.id?.toString() || "",
    amountPerTip: json.amountPerTip,
    dr01: json.dr01,
    dr02: json.dr02,
    dr03: json.dr03,
    drOther: json.drOther,
    drTip: json.drTip,
    personTime: json.personTime,
    total: json.total,
    tr04: json.tr04,
    tr06: json.tr06,
    tr30: json.tr30,
    tr97: json.tr97,
    trOther: json.trOther,
    treatmentDepartmentId: json.treatmentDepartmentId,
    treatmentDepartmentName: json.treatmentDepartmentName,
    treatmentDoctorId: json.treatmentDoctorId,
    treatmentDoctorName: json.treatmentDoctorName,
  };
}
